import { reportData } from '_api/activity-common-template'
import Modal from './components/Modal'
import Modal2 from './components/Modal2'
import TwoBtnModal from './components/two-btn-modal'
import NoData from './components/no-data'
import { utils } from '_lib/utils'
import moment from 'moment'
export const ComponentCommonMixin = {
  props: {
    act_id: {
      type: String,
      default: '',
    },
    cc: { // component_conf
      type: Object,
      default: () => {}
    },
    cd: { // component_data
      type: Object,
      default: () => {}
    },
    gc: { // common_config
      type: Object,
      default: () => {}
    },
    gd: { // common_data
      type: Object,
      default: () => {}
    },
    cpt_name: { // component_name
      type: String,
      default: ''
    },
    querys: { // url参数
      type: Object,
      default: () => {}
    },
    cpt_index: {
      type: Number,
      default: -1,
    }
  },
  components: {
    Modal,
    TwoBtnModal,
    NoData,
    Modal2,
  },
  data () {
    return {
      reportLock: false, // 点击上报锁
      is_in_heybox: utils.isInHeybox()
    }
  },
  methods: {
    reportData (id = '') {
      let index = this.$parent.json.components_data.findIndex(item => item.component_name == this.cpt_name && item.component_conf.index == this.cc.index)
      if (!this.reportLock && this.is_in_heybox) {
        this.reportLock = true
        reportData({
          type: '402',
          act_id: this.querys.act_id,
          // 模块名称+时间戳+特殊id（比如任务模块的某个任务）+模块的index
          report_id: this.cpt_name + '-' + Date.parse(new Date()) + id + (index > -1 ? ('-' + index) : ''),
          heybox_id: this.querys.heybox_id
        }).then(() => {
          this.reportLock = false
        })
      }
    },
    openInHeybox () {
      utils.executeProtocolOutApp({
        "protocol_type": "openWindow",
        "webview": {
          "url": window.location.origin + window.location.pathname + '?act_id=' + this.querys.act_id
        },
        navigation_bar: {
          title: "小黑盒"
        }
      })
      // window.location.href = `https://api.xiaoheihe.cn/heybox/cpt_${this.querys.act_id}/`
    },
    formatDateByTemplet (val, template = 'YYYY-MM-DD HH:mm') {
      return moment(val * 1000).format(template)
    },
    hexToRgba: utils.hexToRgba
  }
}